export const INFINITE_SYMBOL = '∞';
